import React, { PropsWithChildren } from "react";
import * as styles from "./MiniFareCardFooterDisclaimer.module.scss";

const MiniFareCardFooterDisclaimer: React.FC<PropsWithChildren<unknown>> = ({
  children
}) => {
  return <div className={styles.disclaimer}>{children}</div>;
};

export default MiniFareCardFooterDisclaimer;
